import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=e046a1be&scoped=true"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"
import style0 from "./Facebook.vue?vue&type=style&index=0&id=e046a1be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e046a1be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e046a1be')) {
      api.createRecord('e046a1be', component.options)
    } else {
      api.reload('e046a1be', component.options)
    }
    module.hot.accept("./Facebook.vue?vue&type=template&id=e046a1be&scoped=true", function () {
      api.rerender('e046a1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/social/Facebook.vue"
export default component.exports